import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import { Navigation } from 'swiper/modules';
import { breakpoints } from '../../utils/helpers';
import "./style.scss"
import Next from '-!svg-react-loader!../../assets/images/slide-arrow-next.svg';
import Prev from '-!svg-react-loader!../../assets/images/slide-arrow-prev.svg';
import fallback from '../../assets/images/cat.jpg';
import Image from '../../components/image';

const Explore = () => {
    const [swiper, setSwiper] = useState(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const scale = () => { setIsMobile(window.innerWidth < breakpoints.sm); }
        window.addEventListener('resize', scale);
        window.dispatchEvent(new Event('resize'));

        return () => {
            window.removeEventListener('resize', scale)
        }
    }, [])

    const collectionsQuery = useStaticQuery(graphql`
        query {
            allShopifyCollection(filter: {metafields: {elemMatch: {namespace: {eq: "collection"}, key: {eq: "collection_ismain"}, value: {eq: "1"}}}}) {
                nodes {
                    id
                    title
                    handle
                    image {
                        altText
                        src
                    }
                    metafields {
                        key
                        namespace
                        value
                    }
                }
            }
        }
    `)

    const collectionItems = collectionsQuery.allShopifyCollection.nodes;

    collectionItems.forEach(collection => {
        const metadata = collection.metafields
          .filter((field) => field.key === 'collection_page_order')[0]
        if(metadata) {
            collection['order'] = Number(metadata.value)
        } else {
            collection['order'] = collectionItems.length;
        }
    });

    return (
        <section className="Explore">
            {isMobile ? (
                <div className="Explore__mobile">
                    {collectionItems.sort((a, b) => a.order < b.order ? -1 : 1).slice(0, 5).map((item, index) => (
                        <Link to={`/collection/${item.handle}`} key={index}>
                            <div className="Explore__slide__item">
                                <Image source={item.image?.src || fallback} imgClass="Explore__slide__img" />
                                <div className="Explore__slide__badge">
                                    <h3>{item.title}</h3>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            ) : (<>
                <button
                    className="Nav__button next"
                    aria-label="next"
                    onClick={() => swiper.slideNext()}
                ><Next /></button>
                <button
                    className="Nav__button prev"
                    aria-label="prev"
                    onClick={() => swiper.slidePrev()}
                ><Prev /></button>

                <Swiper
                    modules={[Navigation]}
                    pagination={false}
                    spaceBetween={20}
                    slidesPerView={2}
                    preloadimages="false"
                    lazy="true"
                    loop={false}
                    onSwiper={setSwiper}
                    navigation={{
                        nextEl: '.Explore .Nav__button.next',
                        prevEl: '.Explore .Nav__button.prev',
                    }}
                    breakpoints={{
                        [breakpoints.md]: {
                            slidesPerView: 4,
                        },
                        [breakpoints.lg]: {
                            slidesPerView: 5,
                        },
                    }}
                >

                    {collectionItems.sort((a, b) => a.order < b.order ? -1 : 1).map((item, index) => (
                        <SwiperSlide className="Explore__slide" key={index} data-order={item.order}>
                            <Link to={`/collection/${item.handle}`}>
                                <div className="Explore__slide__item">
                                    <Image source={item.image?.src || fallback} imgClass="Explore__slide__img" />
                                    <div className="Explore__slide__badge">
                                        <h3>{item.title}</h3>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                    ))}

                </Swiper>
            </>)}

            <Link to="/shop" className="Button Button__secondary--outline">Shop All Products</Link>
        </section >
    )
}

export default Explore;